import Flex from '@Components/Bases/Flex';
import { FormTextEditor } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { Typography } from '@mui/material';
import { MarketingIndustryFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';
import { useWatch } from 'react-hook-form';
import DisclosureGuidelinesIndustryMarketPolicies from '../DisclosureGuidelines/DisclosureGuidelinesIndustryMarketPolicies';

type MarketPolicyFormValues = {
  marketPolicyIndex: number;
};

const IndustryMarketPoliciesFormFields = ({
  marketPolicyIndex: index,
}: MarketPolicyFormValues) => {
  const { completedSection } =
    useWatch({ name: 'marketingIndustry' }) ??
    ({} as MarketingIndustryFormValues);

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  return (
    <>
      <Flex justifyContent={'space-between'} alignItems={'center'} mt={3}>
        <Typography fontWeight={800}>
          สภาพการแข่งขันภายในอุตสาหกรรมในปีที่ผ่านมา
        </Typography>
        <DisclosureGuidelinesIndustryMarketPolicies />
      </Flex>
      <FormTextEditor
        name={`marketingIndustry.marketingPolicy.${index}.industryCompetitionDescTh`}
        label={'กรุณาอธิบายสภาพการแข่งขันภายในอุตสาหกรรมในปีที่ผ่านมา (ไทย)'}
        inputProps={{ placeholder: 'กรุณาระบุ (ไทย)' }}
        required
        sx={isCompletedTh ? disabledFormInputStyles : {}}
      />
      <FormTextEditor
        name={`marketingIndustry.marketingPolicy.${index}.industryCompetitionDescEn`}
        label={'กรุณาอธิบายสภาพการแข่งขันภายในอุตสาหกรรมในปีที่ผ่านมา (อังกฤษ)'}
        inputProps={{ placeholder: 'กรุณาระบุ (อังกฤษ)' }}
        required
        mt={2}
        sx={isCompletedEn ? disabledFormInputStyles : {}}
      />
    </>
  );
};

export default IndustryMarketPoliciesFormFields;
